import React, { useState } from "react";
import { getAlertIconVentas } from "../utils/get";
import EditarIcon from "../../assets/img/EDITAR.svg";
import VerIcon from "../../assets/img/VER.svg";
import { getLocaleStringRoundedInt } from "../utils/utils";
import DetalleCierreMensualMobileModal from "./Responsive/DetalleCierreMensualMobileModal";
import JustificacionCierreMensualMobileModal from "./Responsive/JustificacionCierreMensualMobileModal";

const VentasTable = ({
  openJustificacion,
  ventas,
  total,
  renderActionButton,
  selectedEds,
  selectedPeriodo,
  pagador,
  callServiceHandler,
  getCierreMensual,
  estadoCierre
}) => {
  const [detalleModal, setDetalleModal] = useState({
    isOpen: false,
    title: "Ventas",
    subtitle: "",
    rows: [],
    isTotal: false
  });

  const [justificacionModal, setJustificacionModal] = useState({
    isOpen: false,
    info: null,
    selectedAction: "editar",
    title: "Ventas",
    subtitle: "",
    rows: []
  });

  const closeDetalleModal = () => {
    setDetalleModal({
      isOpen: false,
      title: "Ventas",
      subtitle: "",
      rows: [],
      isTotal: false
    });
  };

  const closeJustificacionModal = () => {
    setJustificacionModal({
      isOpen: false,
      info: null,
      selectedAction: "editar",
      title: "Ventas",
      subtitle: "",
      rows: []
    });
  };

  const getMaterialName = (material) => {
    return material === "KEROSENE" ? "KERO" : material;
  };

  const formatMoney = (value) => `$ ${getLocaleStringRoundedInt(value)}`;

  const getAlertaText = (alerta) => {
    if (alerta === "VERDE") return "alerta verde";
    if (alerta === "AMARILLA" || alerta === "AMARILLO") return "alerta amarilla";
    if (alerta === "ROJA" || alerta === "ROJO") return "alerta roja";
    return "-";
  };

  const getAlertaContent = (alerta) => {
    return getAlertIconVentas(alerta) || "-";
  };

  const getJustificacionDisplayIcon = (justificacion) => {
    if (justificacion === "INGRESAR") {
      return <img className="cierre-mensual-justificar-icon" src={EditarIcon} alt="" />;
    }

    if (justificacion === "VER") {
      return <img className="cierre-mensual-justificar-icon" src={VerIcon} alt="" />;
    }

    return "-";
  };

  const buildVentaRows = (material) => ([
    { label: "Litros Controlador", value: getLocaleStringRoundedInt(material.LITROS_CONTROLADOR) },
    { label: "Litros Documentados", value: getLocaleStringRoundedInt(material.LITROS_DOCUMENTADOS) },
    { label: "Litros Confirmados", value: getLocaleStringRoundedInt(material.LITROS_CONFIRMADOS) },
    { label: "(Lts) Documentados - Controlador", value: getLocaleStringRoundedInt(material.LITROS_DOCS_MENOS_CTRL) },
    { label: "(Lts) Confirmados - Documentados", value: getLocaleStringRoundedInt(material.LITROS_CONF_MENOS_DOCS) },
    { label: "($) Controlador", value: formatMoney(material.VALOR_CONTROLADOR) },
    { label: "($) Documentado", value: formatMoney(material.VALOR_DOCUMENTADOS) },
    { label: "($) Confirmados", value: formatMoney(material.VALOR_CONFIRMADOS) },
    { label: "($) Documentados - Controlador", value: formatMoney(material.VALOR_DOCS_MENOS_CTRL) },
    { label: "($) Confirmados - Documentados", value: formatMoney(material.VALOR_CONF_MENOS_DOCS) },
    { label: "Alerta", value: getAlertaContent(material.ALERTA) },
    { label: "Justificación", value: getJustificacionDisplayIcon(material.JUSTIFICACION) }
  ]);

  const buildTotalRows = () => ([
    { label: "Litros Controlador", value: getLocaleStringRoundedInt(total?.TOTAL_LITROS_CONTROLADOR) },
    { label: "Litros Documentados", value: getLocaleStringRoundedInt(total?.TOTAL_LITROS_DOCUMENTADOS) },
    { label: "Litros Confirmados", value: getLocaleStringRoundedInt(total?.TOTAL_LITROS_CONFIRMADOS) },
    { label: "(Lts) Documentados - Controlador", value: getLocaleStringRoundedInt(total?.TOTAL_LITROS_DOCS_MENOS_CTRL) },
    { label: "(Lts) Confirmados - Documentados", value: getLocaleStringRoundedInt(total?.TOTAL_LITROS_CONF_MENOS_DOCS) },
    { label: "($) Controlador", value: formatMoney(total?.TOTAL_VALOR_CONTROLADOR) },
    { label: "($) Documentado", value: formatMoney(total?.TOTAL_VALOR_DOCUMENTADOS) },
    { label: "($) Confirmados", value: formatMoney(total?.TOTAL_VALOR_CONFIRMADOS) },
    { label: "($) Documentados - Controlador", value: formatMoney(total?.TOTAL_VALOR_DOCS_MENOS_CTRL) },
    { label: "($) Confirmados - Documentados", value: formatMoney(total?.TOTAL_VALOR_CONF_MENOS_DOCS) }
  ]);

  const openVentaDetalle = (material) => {
    setDetalleModal({
      isOpen: true,
      title: "Ventas",
      subtitle: getMaterialName(material.MATERIAL),
      rows: buildVentaRows(material),
      isTotal: false
    });
  };

  const openTotalDetalle = () => {
    setDetalleModal({
      isOpen: true,
      title: "Ventas",
      subtitle: "TOTAL",
      rows: buildTotalRows(),
      isTotal: true
    });
  };

  const openVentaJustificacionMobile = (material, action) => {
    setJustificacionModal({
      isOpen: true,
      info: material,
      selectedAction: action,
      title: "Ventas",
      subtitle: getMaterialName(material.MATERIAL),
      rows: buildVentaRows(material)
    });
  };

  const getJustificacionContent = (material, isResponsive = false) => {
    if (material.JUSTIFICACION === "INGRESAR") {
      return (
        <img
          className="cierre-mensual-justificar-icon"
          onClick={() => isResponsive ? openVentaJustificacionMobile(material, "editar") : openJustificacion(material, "editar")}
          src={EditarIcon}
          alt=""
        />
      );
    }

    if (material.JUSTIFICACION === "VER") {
      return (
        <img
          className="cierre-mensual-justificar-icon"
          onClick={() => isResponsive ? openVentaJustificacionMobile(material, "ver") : openJustificacion(material, "ver")}
          src={VerIcon}
          alt=""
        />
      );
    }

    return "-";
  };

  return (
    <div className="cierre-mensual-table-section cierre-mensual-ventas-section">
      <div className="cierre-mensual-table-title-row">
        <div className="table-title">VENTAS</div>
        <div className="cierre-mensual-table-title-action">
          {renderActionButton && renderActionButton()}
        </div>
      </div>

      <table className="table-with-material-title cierre-mensual-desktop-table">
        <div className="table-header">
          <div className="legend">
            <div className="material">
              <div className="rect"></div>
              <div className="text">Material Consignado</div>
            </div>
            <div className="material">
              <div className="rect concesionado"></div>
              <div className="text">Material Concesionado</div>
            </div>
          </div>
        </div>
        <thead>
          <tr>
            <th className="no-padding-left"><div className="th-data width-80"><div className="th-text">Material</div></div></th>
            <th><div className="th-data two-lines width-100"><div className="th-text">Litros<br />Controlador</div></div></th>
            <th><div className="th-data two-lines width-100"><div className="th-text">Litros<br />Documentados</div></div></th>
            <th><div className="th-data two-lines width-100"><div className="th-text">Litros<br />Confirmados</div></div></th>
            <th><div className="th-data two-lines width-100"><div className="th-text">(Lts) Docume…<br />- Controlador</div></div></th>
            <th><div className="th-data two-lines width-100"><div className="th-text">(Lts) Confirm.<br />- Document…</div></div></th>
            <th><div className="th-data two-lines width-100"><div className="th-text">($)<br />Controlador</div></div></th>
            <th><div className="th-data two-lines width-100"><div className="th-text">($)<br />Documentado</div></div></th>
            <th><div className="th-data two-lines width-100"><div className="th-text">($)<br />Confirmados</div></div></th>
            <th><div className="th-data two-lines width-100"><div className="th-text">($) Documen…<br />- Controlador</div></div></th>
            <th><div className="th-data two-lines width-100"><div className="th-text">($) Confirm.<br />- Documenta…</div></div></th>
            <th><div className="th-data width-60"><div className="th-text">Alerta</div></div></th>
            <th><div className="th-data width-60"><div className="th-text">Justifi...</div></div></th>
          </tr>
        </thead>
        <tr className="separator-table-row"><th colSpan="100%" /></tr>
        <tbody>
          {ventas ?
            <>
              {ventas.length > 0 ?
                ventas.map((material, index) => (
                  <tr key={`venta-desktop-${material.MATERIAL}-${material.LITROS_CONTROLADOR}-${material.ALERTA}`}>
                    <td className="def-tanque-container">
                      <div className={`type ${material.FORMA_COMERCIALIZACION}`}></div>
                      {getMaterialName(material.MATERIAL)}
                    </td>
                    <td>{getLocaleStringRoundedInt(material.LITROS_CONTROLADOR)}</td>
                    <td>{getLocaleStringRoundedInt(material.LITROS_DOCUMENTADOS)}</td>
                    <td>{getLocaleStringRoundedInt(material.LITROS_CONFIRMADOS)}</td>
                    <td>{getLocaleStringRoundedInt(material.LITROS_DOCS_MENOS_CTRL)}</td>
                    <td>{getLocaleStringRoundedInt(material.LITROS_CONF_MENOS_DOCS)}</td>
                    <td>{formatMoney(material.VALOR_CONTROLADOR)}</td>
                    <td>{formatMoney(material.VALOR_DOCUMENTADOS)}</td>
                    <td>{formatMoney(material.VALOR_CONFIRMADOS)}</td>
                    <td>{formatMoney(material.VALOR_DOCS_MENOS_CTRL)}</td>
                    <td>{formatMoney(material.VALOR_CONF_MENOS_DOCS)}</td>
                    <td className="align-center alerta-container alert-container-cierre-mensual">
                      {getAlertIconVentas(material.ALERTA)}
                      <div className="alert-tooltip"><div className="content">{getAlertaText(material.ALERTA)}</div></div>
                    </td>
                    <td className="align-center">{getJustificacionContent(material)}</td>
                  </tr>
                ))
                :
                <tr className="data"><td className="align-left" colSpan="100%">No se encontró información de ventas del cierre.</td></tr>
              }
            </> :
            <tr><td className="align-left" colSpan="100%">Busca por EDS y por Periodo.</td></tr>
          }
        </tbody>
        {ventas && ventas.length > 0 && <>
          <tr className="separator-table-row"><th colSpan="100%" /></tr>
          <tr className="total-row align-center">
            <td>TOTAL</td>
            <td><div className="total-data">{getLocaleStringRoundedInt(total?.TOTAL_LITROS_CONTROLADOR)}</div></td>
            <td><div className="total-data">{getLocaleStringRoundedInt(total?.TOTAL_LITROS_DOCUMENTADOS)}</div></td>
            <td><div className="total-data">{getLocaleStringRoundedInt(total?.TOTAL_LITROS_CONFIRMADOS)}</div></td>
            <td><div className="total-data">{getLocaleStringRoundedInt(total?.TOTAL_LITROS_DOCS_MENOS_CTRL)}</div></td>
            <td><div className="total-data">{getLocaleStringRoundedInt(total?.TOTAL_LITROS_CONF_MENOS_DOCS)}</div></td>
            <td><div className="total-data">{formatMoney(total?.TOTAL_VALOR_CONTROLADOR)}</div></td>
            <td><div className="total-data">{formatMoney(total?.TOTAL_VALOR_DOCUMENTADOS)}</div></td>
            <td><div className="total-data">{formatMoney(total?.TOTAL_VALOR_CONFIRMADOS)}</div></td>
            <td><div className="total-data">{formatMoney(total?.TOTAL_VALOR_DOCS_MENOS_CTRL)}</div></td>
            <td><div className="total-data">{formatMoney(total?.TOTAL_VALOR_CONF_MENOS_DOCS)}</div></td>
            <td colSpan="2" />
          </tr>
        </>}
      </table>

      <table className="cierre-mensual-responsive-table cierre-mensual-ventas-responsive-table">
        <thead>
          <tr>
            <th><div className="th-data">Material</div></th>
            <th className="cm-tablet-only"><div className="th-data">Litros<br />Confirmados</div></th>
            <th className="cm-tablet-only"><div className="th-data">($) Confirmados</div></th>
            <th><div className="th-data">Alerta</div></th>
            <th><div className="th-data">Justificación</div></th>
          </tr>
        </thead>
        <tbody>
          <tr className="separator-table-row"><th colSpan="100%" /></tr>
          {ventas ?
            <>
              {ventas.length > 0 ?
                ventas.map((material, index) => (
                  <React.Fragment key={`venta-responsive-${material.MATERIAL}-${material.LITROS_CONFIRMADOS}-${material.ALERTA}`}>
                    <tr>
                      <td>{getMaterialName(material.MATERIAL)}</td>
                      <td className="cm-tablet-only">{getLocaleStringRoundedInt(material.LITROS_CONFIRMADOS)}</td>
                      <td className="cm-tablet-only">{formatMoney(material.VALOR_CONFIRMADOS)}</td>
                      <td className="align-center cm-alert-cell">{getAlertIconVentas(material.ALERTA)}</td>
                      <td className="align-center cm-justification-cell">
                        <div className="cm-justification-content">
                          <span className="cm-justification-icon">{getJustificacionContent(material, true)}</span>
                          <button className="cm-row-arrow-button" onClick={() => openVentaDetalle(material)}>
                            <span className="cm-row-arrow"></span>
                          </button>
                        </div>
                      </td>
                    </tr>
                    {index < ventas.length - 1 && <tr className="separator-table-row"><th colSpan="100%" /></tr>}
                  </React.Fragment>
                ))
                :
                <tr><td className="align-left" colSpan="5">No se encontró información de ventas del cierre.</td></tr>
              }
            </> :
            <tr><td className="align-left" colSpan="5">Busca por EDS y por Periodo.</td></tr>
          }

          {ventas && ventas.length > 0 && (
            <>
              <tr className="separator-table-row"><th colSpan="100%" /></tr>
              <tr className="cm-total-row">
                <td>TOTAL</td>
                <td className="cm-tablet-only"><div className="cm-total-pill">{getLocaleStringRoundedInt(total?.TOTAL_LITROS_CONFIRMADOS)}</div></td>
                <td className="cm-tablet-only"><div className="cm-total-pill">{formatMoney(total?.TOTAL_VALOR_CONFIRMADOS)}</div></td>
                <td></td>
                <td className="align-center cm-justification-cell">
                  <div className="cm-justification-content">
                    <span className="cm-justification-icon"></span>
                    <button className="cm-row-arrow-button" onClick={openTotalDetalle}>
                      <span className="cm-row-arrow"></span>
                    </button>
                  </div>
                </td>
              </tr>
            </>
          )}
        </tbody>
      </table>

      <div className="cierre-mensual-mobile-section-action">
        {renderActionButton && renderActionButton()}
      </div>

      <DetalleCierreMensualMobileModal
        isOpen={detalleModal.isOpen}
        closeModal={closeDetalleModal}
        title={detalleModal.title}
        subtitle={detalleModal.subtitle}
        rows={detalleModal.rows}
        isTotal={detalleModal.isTotal}
      />

      <JustificacionCierreMensualMobileModal
        isOpen={justificacionModal.isOpen}
        closeModal={closeJustificacionModal}
        info={justificacionModal.info}
        selectedTable="VENTAS"
        selectedAction={justificacionModal.selectedAction}
        selectedEds={selectedEds}
        selectedPeriodo={selectedPeriodo}
        pagador={pagador}
        callServiceHandler={callServiceHandler}
        getCierreMensual={getCierreMensual}
        estadoCierre={estadoCierre}
        title={justificacionModal.title}
        subtitle={justificacionModal.subtitle}
        rows={justificacionModal.rows}
      />
    </div>
  );
};

export default VentasTable;
